import { PlayerStates } from './PlayerState'
import { PlayerAction, PlayerActions } from './PlayerStateAction'

import type { PlayerState } from './PlayerState.types'

type PlayerReducer = (action: PlayerAction, state: PlayerState) => PlayerState

const reduceWaiting = (action: PlayerAction, state: PlayerState) => {
  if (PlayerActions.isBeginPlay(action)) {
    return PlayerStates.InPlay
  }
  if (PlayerActions.isOut(action)) {
    return PlayerStates.Out
  }
  if (PlayerActions.isSitOut(action)) {
    return PlayerStates.SitOut
  }
  if (PlayerActions.isDisconnect(action)) {
    return PlayerStates.Disconnected
  }
  if (PlayerActions.isObserv(action)) {
    return PlayerStates.Observer
  }

  return state
}

const reduceInPlay = (action: PlayerAction, state: PlayerState) => {
  if (PlayerActions.isWait(action)) {
    return PlayerStates.Waiting
  }
  if (PlayerActions.isFold(action)) {
    return PlayerStates.Folded
  }
  if (PlayerActions.isGoAllIn(action)) {
    return PlayerStates.AllIn
  }
  if (PlayerActions.isOut(action)) {
    return PlayerStates.Out
  }
  if (PlayerActions.isSitOut(action)) {
    return PlayerStates.SitOut
  }
  if (PlayerActions.isDisconnect(action)) {
    return PlayerStates.Disconnected
  }
  if (PlayerActions.isObserv(action)) {
    return PlayerStates.Observer
  }
  if (PlayerActions.isOutForever(action)) {
    return PlayerStates.ForeverOut
  }

  return state
}

const reduceFolded = (action: PlayerAction, state: PlayerState) => {
  if (PlayerActions.isWait(action)) {
    return PlayerStates.Waiting
  }
  if (PlayerActions.isBeginPlay(action)) {
    return PlayerStates.InPlay
  }
  if (PlayerActions.isOut(action)) {
    return PlayerStates.Out
  }
  if (PlayerActions.isSitOut(action)) {
    return PlayerStates.SitOut
  }
  if (PlayerActions.isDisconnect(action)) {
    return PlayerStates.Disconnected
  }
  if (PlayerActions.isObserv(action)) {
    return PlayerStates.Observer
  }

  return state
}

const reduceAllIn = (action: PlayerAction, state: PlayerState) => {
  if (PlayerActions.isWait(action)) {
    return PlayerStates.Waiting
  }
  if (PlayerActions.isBeginPlay(action)) {
    return PlayerStates.InPlay
  }
  if (PlayerActions.isOut(action)) {
    return PlayerStates.Out
  }
  if (PlayerActions.isSitOut(action)) {
    return PlayerStates.SitOut
  }
  if (PlayerActions.isDisconnect(action)) {
    return PlayerStates.Disconnected
  }
  if (PlayerActions.isObserv(action)) {
    return PlayerStates.Observer
  }

  return state
}

const reduceOut = (action: PlayerAction, state: PlayerState) => {
  if (PlayerActions.isWait(action)) {
    return PlayerStates.Waiting
  }
  if (PlayerActions.isBeginPlay(action)) {
    return PlayerStates.InPlay
  }
  if (PlayerActions.isDisconnect(action)) {
    return PlayerStates.Disconnected
  }
  if (PlayerActions.isObserv(action)) {
    return PlayerStates.Observer
  }
  if (PlayerActions.isSitOut(action)) {
    return PlayerStates.SitOut
  }

  return state
}

const reduceSitOut = (action: PlayerAction, state: PlayerState) => {
  if (PlayerActions.isWait(action)) {
    return PlayerStates.Waiting
  }
  if (PlayerActions.isBeginPlay(action)) {
    return PlayerStates.InPlay
  }
  if (PlayerActions.isDisconnect(action)) {
    return PlayerStates.Disconnected
  }
  if (PlayerActions.isObserv(action)) {
    return PlayerStates.Observer
  }
  if (PlayerActions.isOut(action)) {
    return PlayerStates.Out
  }
  if (PlayerActions.isSitOut(action)) {
    return PlayerStates.SitOut
  }

  return state
}

const reduceForeverOut = (action: PlayerAction, state: PlayerState) => {
  if (PlayerActions.isWait(action)) {
    return PlayerStates.Waiting
  }
  if (PlayerActions.isBeginPlay(action)) {
    return PlayerStates.InPlay
  }
  if (PlayerActions.isOut(action)) {
    return PlayerStates.Out
  }
  if (PlayerActions.isSitOut(action)) {
    return PlayerStates.SitOut
  }
  if (PlayerActions.isDisconnect(action)) {
    return PlayerStates.Disconnected
  }

  return state
}

const reduceDisconnected = (action: PlayerAction, state: PlayerState) => {
  if (PlayerActions.isWait(action)) {
    return PlayerStates.Waiting
  }
  if (PlayerActions.isBeginPlay(action)) {
    return PlayerStates.InPlay
  }
  if (PlayerActions.isObserv(action)) {
    return PlayerStates.Observer
  }

  return state
}

const reduceObserver = (action: PlayerAction, state: PlayerState) => {
  if (PlayerActions.isWait(action)) {
    return PlayerStates.Waiting
  }
  if (PlayerActions.isBeginPlay(action)) {
    return PlayerStates.InPlay
  }
  if (PlayerActions.isObserv(action)) {
    return PlayerStates.Observer
  }

  return state
}

export const PlayerReducer: PlayerReducer = (action: PlayerAction, state: PlayerState) => {
  if (PlayerStates.isWaiting(state)) {
    return reduceWaiting(action, state)
  }
  if (PlayerStates.isForeverOut(state)) {
    return reduceForeverOut(action, state)
  }
  if (PlayerStates.isInPlay(state)) {
    return reduceInPlay(action, state)
  }
  if (PlayerStates.isFolded(state)) {
    return reduceFolded(action, state)
  }
  if (PlayerStates.isAllIn(state)) {
    return reduceAllIn(action, state)
  }
  if (PlayerStates.isOut(state)) {
    return reduceOut(action, state)
  }
  if (PlayerStates.isSitOut(state)) {
    return reduceSitOut(action, state)
  }
  if (PlayerStates.isDisconnected(state)) {
    return reduceDisconnected(action, state)
  }
  if (PlayerStates.isObserver(state)) {
    return reduceObserver(action, state)
  }
  return state
}
